import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
export function useLinkBehavior(props) {
  var givenRole = props.role,
      href = props.href,
      givenTabIndex = props.tabIndex,
      givenOnKeyDown = props.onKeyDown,
      hasButtonBehavior = props.hasButtonBehavior,
      redirect = props.redirect; // If there's no @href, the `<a />` should be treated like a button.

  var role = typeof givenRole === 'undefined' && typeof href === 'undefined' ? 'button' : givenRole;
  var hasButtonRole = role === 'button'; // A "button" should always be able to receive focus, but an `<a />` cannot
  // receive focus if it has no @href, so we give a tabIndex if a value is not
  // explicitly provided.

  var tabIndex = typeof givenTabIndex === 'undefined' && hasButtonRole ? 0 : givenTabIndex;

  var onKeyDown = function onKeyDown(event) {
    // simulate button behavior
    if (hasButtonBehavior || hasButtonRole) {
      switch (event.key) {
        // buttons treat space chars as click events, so we replicate that here
        case ' ':
        case 'Spacebar':
          event.currentTarget.click();
          break;
      }
    }

    if (typeof givenOnKeyDown === 'function') {
      givenOnKeyDown(event);
    }
  };

  var _useState = useState(href),
      _useState2 = _slicedToArray(_useState, 2),
      windowAwareHref = _useState2[0],
      setHref = _useState2[1];

  useEffect(function () {
    if (redirect) {
      setHref("".concat(href, "?redirect=").concat(encodeURIComponent(window.location.href)));
    }
  }, []);
  return {
    role: role,
    tabIndex: tabIndex,
    onKeyDown: onKeyDown,
    href: windowAwareHref
  };
}